import React, { useContext, useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Tilt from "react-parallax-tilt";
import { AppContext } from "../../../Contexts/AppContext";
import FilterProject from "./FilterProject";
import LoadingSpinner from "../../Loading/LoadingSpinner";

const Tutorials = () => {
  const context = useContext(AppContext);
  const [currentBG, setCurrentBG] = useState("");
  const [currentText, setCurrentText] = useState("");
  const [currentColor, setCurrentColor] = useState("");
  const [tutorials, setTutorials] = useState(null);
  const [showDesc, setShowDesc] = useState({});
  const [filtered, setFiltered] = useState(null);
  const [activeCategory, setActiveCategory] = useState("All");
  const [isLoading, setIsLoading] = useState(true);

  const getTutorials = async () => {
    setIsLoading(true);
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_YARN_HEAVEN_URL}/api/tutorials`,
      {
        method: "GET",
      }
    );
    const result = await response.json();
    setFiltered(result.data);
    setTutorials(result.data);
    setIsLoading(false);
  };

  useEffect(() => {
    getTutorials();
  }, []);

  useEffect(() => {
    setCurrentBG(
      context.isLight
        ? context.currentTheme["business"].bg
        : context.currentTheme["business"].dark_bg
    );
    setCurrentText(
      context.isLight
        ? context.currentTheme["business"].text
        : context.currentTheme["business"].dark_text
    );
    setCurrentColor(
      context.isLight
        ? context.currentTheme["business"].dropdown
        : context.currentTheme["business"].dark_dropdown
    );
  }, [context]);
  return !isLoading ? (
    <div id="tutorials" className="py-1" style={{ backgroundColor: currentBG }}>
      <FilterProject
        tutorials={tutorials}
        setFiltered={setFiltered}
        activeCategory={activeCategory}
        setActiveCategory={setActiveCategory}
      />
      <motion.div
        layout
        className="projects-list-container mb-5 flex flex-wrap items-center justify-center px-4 md:px-10 xl:px-20"
      >
        <AnimatePresence>
          {filtered.length > 0 ? (
            filtered.map((tutorial) => (
              <motion.div
                key={tutorial._id}
                layout
                initial={{
                  opacity: 0,
                }}
                animate={{
                  opacity: 1,
                }}
                exit={{
                  opacity: 0,
                }}
                onMouseEnter={() => setShowDesc({ [tutorial._id]: true })}
                onMouseLeave={() => setShowDesc({ [tutorial._id]: false })}
              >
                <Tilt
                  tiltMaxAngleX={2}
                  tiltMaxAngleY={2}
                  perspective={1000}
                  className="relative m-4 flex w-[90vw] flex-col items-stretch truncate rounded shadow-lg transition-all duration-300 ss:w-96"
                  style={{ backgroundColor: currentText, color: currentBG }}
                >
                  <img
                    src={`${process.env.REACT_APP_BACKEND_YARN_HEAVEN_URL}/${tutorial.images[0]}`}
                    alt={tutorial.images[0]}
                    className="h-60 w-full object-cover object-center"
                  />
                  <div className="relative flex flex-1 flex-col">
                    <h2 className="logo-font relative w-fit cursor-default py-3 px-2 pt-1 text-xl font-bold ss:py-5 ss:pt-3 ss:text-2xl">
                      {tutorial.title}
                    </h2>
                    <div className="m-2 mt-auto flex items-center justify-between">
                      <a
                        href={tutorial.video}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-fit rounded-full bg-[#df7861] py-1 px-1 text-sm xs:px-2 ss:text-base"
                      >
                        View Tutorial
                      </a>
                      <div className="flex items-center justify-center">
                        <p
                          className="rounded-full border-2 px-2 text-sm font-semibold xs:mr-1"
                          title="category"
                          style={{
                            borderColor: currentColor,
                            color: currentColor,
                          }}
                        >
                          {tutorial.category.catName}
                        </p>
                        {tutorial.user && (
                          <p
                            className="ml-1 rounded-full border-2 px-2 text-sm font-semibold"
                            title="category"
                            style={{
                              borderColor: currentColor,
                              color: currentColor,
                            }}
                          >
                            {tutorial.user.username}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                  <AnimatePresence>
                    {showDesc[tutorial._id] && (
                      <motion.div
                        initial={{
                          y: "-16rem",
                        }}
                        animate={{
                          y: 0,
                          transition: {
                            duration: 0.5,
                            ease: "easeInOut",
                          },
                        }}
                        exit={{
                          y: "-16rem",
                          transition: {
                            duration: 0.2,
                            ease: "easeInOut",
                          },
                        }}
                        className="absolute flex h-60 w-full flex-col items-center justify-center px-2 text-xs font-bold uppercase text-white backdrop-blur xs:text-sm ss:text-base"
                        style={{
                          backgroundColor: "#26172caa",
                        }}
                      >
                        {tutorial.description.map((desc) => (
                          <p>{desc}</p>
                        ))}
                      </motion.div>
                    )}
                  </AnimatePresence>
                </Tilt>
              </motion.div>
            ))
          ) : (
            <p className="py-24 md:py-40 md:text-3xl">
              No projects exist for this Category
            </p>
          )}
        </AnimatePresence>
      </motion.div>
    </div>
  ) : (
    <LoadingSpinner name="Tutorials" />
  );
};

export default Tutorials;
